// These type assertions allow us to do some advanced typescript type magic and are ok.
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-explicit-any */

import _ from "lodash";
import { validate as baseValidate } from "tmt_api/src/types/types.validator";
import { store } from "../redux/index";
import { errorFactory } from "./errorFactory";

export type tCheckoutError = {
  buyerEmail?: string;
  error?: { code?: "incorrect_cvc" | "card_declined" | "fraudulent" };
};

export type tDraft<T> = T & { draftState: true };
export type tFinalDraft<T> = T & { draftState: boolean };
export type tFinal<T> = RecursiveReadonly<T & { draftState: false }>;
export const makeDRAFT = <T>(obj: T): tDraft<T> => ({ ...obj, draftState: true });
export const makeFinal = <T>(obj: T): tFinal<T> => ({ ...obj, draftState: false } as tFinal<T>);
export const makeFinalDRAFT = <T>(obj: tFinalDraft<T>): tFinal<T> => {
  obj.draftState = false;
  return obj as tFinal<T>;
};

export type RecursiveReadonly<T> = {
  readonly [P in keyof T]: RecursiveReadonly<T[P]>;
};

export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends Array<infer U> ? Array<Value<U>> : Value<T[P]>;
};
type AllowedPrimitives =
  | boolean
  | string
  | number
  | Date /* add any types than should be considered as a value, say, DateTimeOffset */;
type Value<T> = T extends AllowedPrimitives ? T : RecursivePartial<T>;

declare type Primitive = string | number | bigint | boolean | symbol | undefined;
export declare type PropertyStringPath<T, Prefix = ""> = {
  [K in keyof T]: T[K] extends Primitive | Array<any>
    ? `${string & Prefix}${string & K}`
    : `${string & Prefix}${string & K}` | PropertyStringPath<NonNullable<T[K]>, `${string & Prefix}${string & K}.`>;
}[keyof T];

/**
 * This wraps the basic validation in an error handler.
 */

type tType = typeof baseValidate;
type tTypeParam = Parameters<tType>[0];
export const validate: tType =
  (typeName) =>
  (value): any => {
    try {
      return baseValidate(typeName as tTypeParam)(value) as any;
    } catch (e) {
      store.dispatch({ type: "RIBBON", message: new Error("Oops!  Data didn't match what was expected!") });
      const error = errorFactory(e);
      // Moved to RIBBON! errorHandler/actions.ts thunk action
      // const s = store.getState() as tReduxState;
      // firebase
      //   .analytics()
      //   .logEvent(
      //     `Error: ${s.UserReducer.profile.firstName} ${s.UserReducer.profile.lastName} of ${s.UserReducer.profile.companyRefPath} had an error: ${e} \nStack: \n${error.stack}`,
      //   );
      throw new Error(error.message);
    }
  };
